module.exports = __webpack_public_path__ + "img/detection_03_IR.990d0692.jpg";